import React from 'react';
import { SnackbarProvider } from 'notistack';
import { observer } from 'mobx-react-lite';
import { FlagsProvider } from 'flagged';
import { useRootStore } from '../../mobx/bridge';
import LoginScreen from './Main/LoginScreen/LoginScreen';
import Main from './Main/Main';
import styles from '../../assets/stylesheets/common.module.css';
import socketIo from '../../socket/socketIo';
import CustomSnackbar from './Main/CustomSnackbar/CustomSnackbar';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const App = observer(function App() {
  const { commonStore, sendingEvents, featureFlagStore } = useRootStore();

  React.useEffect(() => {
    commonStore.unlockSound();

    if (commonStore.loginToken) {
      socketIo.loginSocket.connect();
      commonStore.setAuthenticationLoading(true);
      sendingEvents.socketEmitClientLogin(null, null, commonStore.loginToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.kukuiConnect}>
      {commonStore.loggedIn ? (
        <FlagsProvider features={featureFlagStore.getEnabledFeatureFlags}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            maxSnack={10}
            content={(key, message) => <CustomSnackbar id={key} message={message} />}
          >
            <Main />
          </SnackbarProvider>
        </FlagsProvider>
      ) : (
        <LoginScreen />
      )}
    </div>
  );
});
App.whyDidYouRender = true;
App.displayName = 'App';

export default App;
